// tslint:disable: max-line-length
import React from 'react';

const NoNotification = () => {
  return (
    <svg
      width="110"
      height="96"
      viewBox="0 0 110 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="49.1304"
        y="67.6329"
        width="11.7391"
        height="4.75949"
        fill="#8AC6C1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M56.1738 72.3924H60.8695V67.6329H56.1738V72.3924Z"
        fill="#66B4AD"
      />
      <rect
        x="49.1304"
        y="67.6329"
        width="11.7391"
        height="4.75949"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
      <rect
        x="49.1304"
        y="11.7089"
        width="11.7391"
        height="3.56962"
        fill="#8AC6C1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M56.1738 15.2785H60.8695V11.7089H56.1738V15.2785Z"
        fill="#66B4AD"
      />
      <rect
        x="49.1304"
        y="11.7089"
        width="11.7391"
        height="3.56962"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
      <path
        d="M10.2185 74.3824C10.3992 73.2927 11.287 72.3925 12.3915 72.3925H97.6089C98.7135 72.3925 99.6013 73.2927 99.782 74.3824C100.215 76.992 101.442 79.8282 103.276 81.3151L105.478 83.1013H4.52197L6.72478 81.3151C8.5584 79.8282 9.78583 76.992 10.2185 74.3824Z"
        fill="#B4DCD9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M85.5217 83.1013H105.478L103.275 81.3151C101.442 79.8282 100.214 76.992 99.7817 74.3824C99.601 73.2927 98.7133 72.3925 97.6087 72.3925H82C82 75.1688 82.7043 81.1975 85.5217 83.1013Z"
        fill="#94CAC5"
      />
      <path
        d="M10.2185 74.3824C10.3992 73.2927 11.287 72.3925 12.3915 72.3925H97.6089C98.7135 72.3925 99.6013 73.2927 99.782 74.3824C100.215 76.992 101.442 79.8282 103.276 81.3151L105.478 83.1013H4.52197L6.72478 81.3151C8.5584 79.8282 9.78583 76.992 10.2185 74.3824Z"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
      <path
        d="M45.6089 17.2784C45.6089 16.1739 46.5043 15.2784 47.6089 15.2784H62.3915C63.4961 15.2784 64.3915 16.1739 64.3915 17.2784V21.2278H45.6089V17.2784Z"
        fill="#CFEDEB"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
      <rect
        x="1"
        y="83.1013"
        width="108"
        height="11.8987"
        rx="2"
        fill="#CFEDEB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M85.522 95.0001H107C108.105 95.0001 109 94.1046 109 93.0001V85.1013C109 83.9967 108.105 83.1013 107 83.1013H85.522V95.0001Z"
        fill="#AADEDA"
      />
      <rect
        x="1"
        y="83.1013"
        width="108"
        height="11.8987"
        rx="2"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
      <path
        d="M55 20.038C32.3083 20.038 13.9131 36.5524 13.9131 56.924H96.087C96.087 36.5524 77.6917 20.038 55 20.038Z"
        fill="#B4DCD9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M57.0742 20.0842C74.9653 24.3132 81.9999 38.941 81.9999 56.9241L96.0869 56.9241C96.0869 37.177 78.8021 21.0542 57.0742 20.0842Z"
        fill="#94CAC5"
      />
      <path
        d="M55 20.038C32.3083 20.038 13.9131 36.5524 13.9131 56.924H96.087C96.087 36.5524 77.6917 20.038 55 20.038Z"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
      <path
        d="M10.3911 60.9241C10.3911 58.7149 12.182 56.9241 14.3911 56.9241H95.6085C97.8176 56.9241 99.6085 58.7149 99.6085 60.9241V65.6329C99.6085 66.7375 98.7131 67.6329 97.6085 67.6329H12.3911C11.2865 67.6329 10.3911 66.7375 10.3911 65.6329V60.9241Z"
        fill="#CFEDEB"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
      <path
        d="M10.3911 60.9241C10.3911 58.7149 12.182 56.9241 14.3911 56.9241H95.6085C97.8176 56.9241 99.6085 58.7149 99.6085 60.9241V65.6329C99.6085 66.7375 98.7131 67.6329 97.6085 67.6329H12.3911C11.2865 67.6329 10.3911 66.7375 10.3911 65.6329V60.9241Z"
        fill="#CFEDEB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M95.6087 56.9241H82V67.6329H97.6087C98.7133 67.6329 99.6087 66.7375 99.6087 65.6329V60.9241C99.6087 58.7149 97.8178 56.9241 95.6087 56.9241Z"
        fill="#AADEDA"
      />
      <path
        d="M10.3911 60.9241C10.3911 58.7149 12.182 56.9241 14.3911 56.9241H95.6085C97.8176 56.9241 99.6085 58.7149 99.6085 60.9241V65.6329C99.6085 66.7375 98.7131 67.6329 97.6085 67.6329H12.3911C11.2865 67.6329 10.3911 66.7375 10.3911 65.6329V60.9241Z"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
      <path
        d="M42.0869 10.7353C42.0869 5.35865 46.3871 1 51.6917 1H58.3083C63.6128 1 67.913 5.35865 67.913 10.7353C67.913 11.273 67.483 11.7089 66.9525 11.7089H43.0474C42.5169 11.7089 42.0869 11.273 42.0869 10.7353Z"
        fill="#CFEDEB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M56.4419 1C60.1764 2.51948 62.0437 6.77349 62.0437 11.7089H66.9528C67.4832 11.7089 67.9133 11.273 67.9133 10.7353C67.9133 5.35865 63.6131 1 58.3085 1H56.4419Z"
        fill="#AADEDA"
      />
      <path
        d="M42.0869 10.7353C42.0869 5.35865 46.3871 1 51.6917 1H58.3083C63.6128 1 67.913 5.35865 67.913 10.7353C67.913 11.273 67.483 11.7089 66.9525 11.7089H43.0474C42.5169 11.7089 42.0869 11.273 42.0869 10.7353Z"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
      <ellipse
        cx="87.8695"
        cy="27.1772"
        rx="11.7391"
        ry="11.8987"
        fill="#CFEDEB"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
      <path
        d="M87.8839 34.3164C84.2101 34.3164 82 31.7498 82 27.1341C82 22.5184 84.2101 20.038 87.8839 20.038C91.5291 20.038 93.7391 22.5184 93.7391 27.1341C93.7391 31.7498 91.5291 34.3164 87.8839 34.3164ZM87.8839 32.8929C90.0079 32.8929 91.443 31.1674 91.443 27.1341C91.443 23.1007 90.0079 21.4615 87.8839 21.4615C85.7313 21.4615 84.2962 23.1007 84.2962 27.1341C84.2962 31.1674 85.7313 32.8929 87.8839 32.8929Z"
        fill="#6EB7B1"
        stroke="#4AA49D"
        stroke-width="0.5"
      />
    </svg>
  );
};

export default NoNotification;
